import { Radio, Tooltip, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { VerificationHead } from '../../SendWithoutContactCard/style';

const OverviewWrapper = styled.div``;

const DigitalWrapperContainer = styled.div``;

const DatePickerTooltip = styled.div`
  ${Tooltip.S.Tooltip} {
    width: 100%;
  }
`;

const ViewRecipientExperienceWrapper = styled.div`
  background-color: var(--color-gray-25);
  border-radius: var(--size-border-radius-md);
  margin-bottom: 16px;
`;

const GiftsWrapper = styled.div`
  ${VerificationHead} {
    padding: 16px 16px 0 16px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const AddingMethods = styled.div`
  margin-top: 12px;

  &::after {
    background-color: var(--color-accent-secondary-weaker);
    clear: both;
    content: '';
    display: block;
    height: 1px;
    margin-top: 16px;
    width: 100%;
  }
`;

const AddingMethodsBody = styled.div`
  align-items: center;
  display: flex;
`;

const AddingMethodsTitle = styled(Typography)`
  width: 180px;
`;

const AddingMethodsList = styled.div`
  align-items: center;
  display: flex;
  gap: 40px;
`;

const AddingMethodsListItem = styled(Radio)``;

const Bold = styled.span`
  font-weight: 700;
`;

const Description = styled(Typography)`
  margin-top: 24px;
`;

export {
  AddingMethods,
  AddingMethodsBody,
  AddingMethodsList,
  AddingMethodsListItem,
  AddingMethodsTitle,
  Bold,
  DatePickerTooltip,
  Description,
  DigitalWrapperContainer,
  GiftsWrapper,
  OverviewWrapper,
  Row,
  ViewRecipientExperienceWrapper
};
